import TarfinProInfoService from '@/services/retailer/TarfinProInfoService'

import { errorMessage } from '@/utilities/helpers.js'

export const namespaced = true

export const state = {
  tarfinProInfoText: null
}

export const mutations = {
  SET_TARFIN_PRO_INFO_TEXT(state, info) {
    state.tarfinProInfoText = info
  }
}

export const actions = {
  getTarfinProInfoText({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      TarfinProInfoService.getTarfinProInfoText()
        .then(response => {
          commit('SET_TARFIN_PRO_INFO_TEXT', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
